import { Dialog, DialogContent } from "@mui/material";

const Modal = ({ open, openSet, children, maxWidth = "lg", customWidth }) => {
  function handleClose() {
    open && openSet(false);
  }
  
  // If customWidth is provided, use PaperProps to set custom width
  // Otherwise use standard maxWidth prop
  const dialogProps = customWidth
    ? {
        maxWidth: false,
        fullWidth: true,
        PaperProps: {
          sx: {
            width: customWidth,
            maxWidth: customWidth,
          },
        },
      }
    : {
        maxWidth: maxWidth,
        fullWidth: true,
      };

  return (
    <Dialog open={open} onClose={handleClose} {...dialogProps}>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export default Modal;
